module.exports = __webpack_public_path__ + "img/Päuschen.d74fc9e8.jpg";